const IconHotelOnly = props => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		{...props}
	>
		<path
			d="M1.3335 18.3333C1.3335 18.1492 1.48273 18 1.66683 18H18.3335C18.5176 18 18.6668 18.1492 18.6668 18.3333C18.6668 18.5174 18.5176 18.6667 18.3335 18.6667H1.66683C1.48273 18.6667 1.3335 18.5174 1.3335 18.3333Z"
			fill="currentColor"
			stroke="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.54175 9.16667C8.54175 7.90102 9.56775 6.875 10.8334 6.875H15.8334C17.0991 6.875 18.1251 7.90102 18.1251 9.16667V18.3333C18.1251 18.6785 17.8452 18.9583 17.5001 18.9583H13.3334C13.6786 18.9583 13.9584 18.6785 13.9584 18.3333V15.8333C13.9584 15.4882 13.6786 15.2083 13.3334 15.2083C12.9882 15.2083 12.7084 15.4882 12.7084 15.8333V18.3333C12.7084 18.6785 12.9882 18.9583 13.3334 18.9583H9.16675C8.82158 18.9583 8.54175 18.6785 8.54175 18.3333V9.16667ZM11.8751 10.8333C11.8751 10.4882 12.1549 10.2083 12.5001 10.2083H14.1667C14.5119 10.2083 14.7917 10.4882 14.7917 10.8333C14.7917 11.1785 14.5119 11.4583 14.1667 11.4583H12.5001C12.1549 11.4583 11.8751 11.1785 11.8751 10.8333ZM11.8751 13.3333C11.8751 12.9882 12.1549 12.7083 12.5001 12.7083H14.1667C14.5119 12.7083 14.7917 12.9882 14.7917 13.3333C14.7917 13.6785 14.5119 13.9583 14.1667 13.9583H12.5001C12.1549 13.9583 11.8751 13.6785 11.8751 13.3333Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.875 3.33329C1.875 2.06764 2.90102 1.04163 4.16667 1.04163H10.8333C12.099 1.04163 13.125 2.06764 13.125 3.33329V5.79163H10.8333C8.96933 5.79163 7.45833 7.30267 7.45833 9.16663V18.3333C7.45833 18.5539 7.50014 18.7647 7.57627 18.9583H2.5C2.15483 18.9583 1.875 18.6785 1.875 18.3333V12.2916H4.38927C4.73444 12.2916 5.01427 12.0118 5.01427 11.6666C5.01427 11.3215 4.73444 11.0416 4.38927 11.0416H1.875V8.95829H4.38927C4.73444 8.95829 5.01427 8.67846 5.01427 8.33329C5.01427 7.98812 4.73444 7.70829 4.38927 7.70829H1.875V5.62496H4.38927C4.73444 5.62496 5.01427 5.34513 5.01427 4.99996C5.01427 4.65478 4.73444 4.37496 4.38927 4.37496H1.875V3.33329Z"
			fill="currentColor"
		/>
	</svg>
);

export default IconHotelOnly;
